module.exports = __webpack_public_path__ + "img/intent_5.4ef7e463.png";